import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

const SidebarMenu = ({ toggleDrawer, portal, navPages, open }) => {
  return (
    <div onClick={toggleDrawer} style={{ position: 'relative' }}>
      <SwipeableDrawer
        open={open}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
        className="sidebar-area mobile-sidebar-menu "
      >
        <div className="iron-app-logo-sidebar">
          <Link to="/">
            {portal.logo?.url ? (
              <img
                src={portal.logo.url}
                alt="UserImage"
                className="img-responsive"
                key={portal.logo.url}
                onClick={open ? toggleDrawer : () => {}}
              />
            ) : null}
          </Link>
        </div>

        <div className="vertical-menu mf-py-40">
          <ul className="sidebar-links">{navPages}</ul>
        </div>
      </SwipeableDrawer>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    portal: state.portal
  }
}

export default connect(mapStateToProps)(SidebarMenu)
